import PropTypes from "prop-types";

const propTypes = {
  children: PropTypes.node
};

export default propTypes;
